import React from 'react';
import skinsStyles from './styles/BoxScreen.scss';
import BaseScreenSkin, { BaseScreenSkinProps } from './BaseScreenSkin';

const BoxScreen: React.FC<
  Omit<BaseScreenSkinProps, 'skin' | 'skinStyles'>
> = props => <BaseScreenSkin {...props} skinStyles={skinsStyles} />;

export default BoxScreen;
